import NotFound from "@/components/common/pages/not-found";
import { Link, Outlet, createFileRoute } from "@tanstack/react-router";
import { Toaster } from "sonner";

export const Route = createFileRoute("/_auth")({
  component: AuthLayoutComponent,
  notFoundComponent: () => <NotFound />,
});

function AuthLayoutComponent() {
  return (
    <>
      <Toaster />
      <div className="grid h-svh min-h-[1080px] w-full p-4 lg:grid-cols-2">
        <div className="flex flex-col gap-4 p-6 md:p-10">
          <div className="flex items-center justify-center gap-2 md:justify-start">
            <img
              className="h-fit w-32"
              src="/logo.png"
              alt="Logo"
              width={100}
              height={100}
            />
            {/* <span className="text-gray-800 text-sm">
              {" "}- AI for Distributors
            </span> */}
          </div>
          <div className="flex flex-1 flex-col items-center justify-center">
            <div className="w-full max-w-xs">
              <Outlet />

              <div className="mx-auto mt-20 flex flex-row justify-center gap-2 py-4 text-center text-sm">
                <Link to="/docs/privacy-policy">Privacy Policy</Link>
                <Link to="/docs/tos">Terms of Service</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="relative hidden flex-col rounded-md bg-brand-yellowGreen p-18 lg:flex">
          {/* Floating Fruits */}
          {/* Top left - Tomato */}
          <img
            src="/fruits/tomato.svg"
            alt="Tomato"
            className="-left-20 absolute top-32 hidden size-42 rotate-12 transform xl:block"
          />

          {/* Top right - Orange */}
          <img
            src="/fruits/orange.svg"
            alt="Orange"
            className="absolute top-4 right-12 hidden size-80 rotate-12 transform xl:block"
          />

          {/* Bottom left - Lemon */}
          <img
            src="/fruits/lemon.svg"
            alt="Lemon"
            className="absolute bottom-32 left-12 hidden size-60 transform xl:block"
          />

          {/* Bottom right - Grapes */}
          <img
            src="/fruits/grapes.svg"
            alt="Grapes"
            className="-rotate-2 absolute right-8 bottom-16 hidden size-72 transform xl:block"
          />

          <img
            className="mb-72 h-fit w-96"
            src="/logo.png"
            alt="Logo"
            width={100}
            height={100}
          />

          <div className="flex flex-col gap-4">
            <h1 className="font-medium text-4xl text-brand-darkGreen lg:text-6xl">
              AI-First Operating System for Food Distributors
            </h1>
            <p className="max-w-3xl font-medium text-brand-darkGreen text-lg xl:text-xl">
              Manage orders, track demand trends, with the best distribution
              channels for maximum efficiency. It's your intelligent assistant
              to ensure food reaches the right place, at the right time, with
              minimal waste.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
